<template>
  <div class="category-list-page">
    <div class="pc-card">
      <div class="pc-card__header">
        <div class="pc-card__title-wrap">
          <span class="pc-card__icon" aria-hidden="true">
            <CIcon name="navProducts"/>
          </span>
          <div>
            <h1 class="pc-card__title">لیست دسته‌بندی</h1>
            <p class="pc-card__sub">
              {{ catId === '0' || catId === 0 ? 'مدیریت دسته‌های اصلی محصولات' : 'مدیریت زیر‌دسته‌های این دسته' }}
            </p>
          </div>
        </div>
        <div class="pc-toolbar">
          <button
            v-if="catId !== '0' && catId !== 0"
            type="button"
            class="pc-btn pc-btn--ghost"
            @click="$router.push({ path: '/dashboard/products/category/0' })"
          >
            <CIcon name="iconChevronRight"/>
            <span>بازگشت به اصلی</span>
          </button>
          <button type="button" class="pc-btn pc-btn--primary" @click="openCreateModal()">
            <CIcon name="iconPlus"/>
            <span>افزودن دسته جدید</span>
          </button>
        </div>
      </div>

      <div class="pc-card__body">
        <CDataTableFixed
          class="pc-table"
          :items="items"
          :fields="fields"
          column-filter
          :items-per-page="20"
          hover
          sorter
          pagination
          :loading="tableLoading"
          :noItemsView="{ noItems: 'دسته‌ای یافت نشد' }"
        >
          <template #no-items-view>
            <div class="pc-empty">
              <span class="pc-empty__icon" aria-hidden="true">
                <CIcon name="navProducts"/>
              </span>
              <p class="pc-empty__title">دسته‌ای یافت نشد</p>
              <p class="pc-empty__sub">برای شروع، یک دسته جدید اضافه کنید.</p>
              <button type="button" class="pc-btn pc-btn--primary" @click="openCreateModal()">
                <CIcon name="iconPlus"/>
                <span>افزودن دسته جدید</span>
              </button>
            </div>
          </template>

          <template #row="{item}">
            <td>
              <span class="pc-muted">{{ item.row_id + 1 }}</span>
            </td>
          </template>

          <template #image="{item}">
            <td>
              <div class="pc-thumb" v-if="item.image">
                <CImg width="44px" height="44px" :src="item.image"/>
              </div>
              <span v-else class="pc-muted">—</span>
            </td>
          </template>

          <template #name="{item}">
            <td>
              <span class="pc-name">{{ item.name }}</span>
            </td>
          </template>

          <template #operation="{item}">
            <td class="pc-ops-cell">
              <div class="pc-ops">
                <button
                  type="button"
                  class="pc-btn pc-btn--sm pc-btn--ghost"
                  title="محصولات"
                  @click="$router.push({ path: '/dashboard/products/list/' + item.id })"
                >
                  <CIcon name="navProducts"/>
                  <span>محصولات</span>
                </button>
                <button
                  type="button"
                  class="pc-btn pc-btn--sm pc-btn--ghost"
                  title="زیردسته‌ها"
                  @click="goSubCategories(item)"
                >
                  <CIcon name="iconList"/>
                  <span>زیردسته</span>
                </button>
                <button type="button" class="pc-icon-btn pc-icon-btn--warn" title="ویرایش" @click="openEditModal(item)">
                  <CIcon name="iconEdit"/>
                </button>
                <button type="button" class="pc-icon-btn pc-icon-btn--danger" title="حذف" @click="delete_item_dialog(item)">
                  <CIcon name="iconTrash"/>
                </button>
              </div>
            </td>
          </template>
        </CDataTableFixed>
      </div>
    </div>

    <CModal
      :show.sync="form_modal"
      :centered="true"
      size="lg"
      :title="status_form == 0 ? 'افزودن دسته جدید' : 'ویرایش دسته'"
      @update:show="onFormModalToggle"
    >
      <div class="pc-form">
        <CRow>
          <CCol col="12" md="6">
            <CInput
              v-model="name"
              class="required"
              label="نام دسته"
              placeholder="نام دسته"
            />
          </CCol>
          <CCol col="12">
            <CTextarea
              v-model="description"
              label="توضیحات دسته"
              placeholder="توضیحات"
              rows="4"
            />
          </CCol>
          <CCol col="12">
            <ImageSelector
              label="تصویر"
              class="required"
              :media_id.sync="file"
              default_archive="product_category"
              :preview-image="previewImage"
            />
          </CCol>
          <CCol col="12" class="mt-3">
            <SeoBox ref="seo"
                    entity-type="category"
                    :entity-id="status_form"
                    :name="name"
                    :slug="seoSlug(name)"
                    url-prefix="/shop/cat/"
                    :content-html="seoHtml(description)"
                    :title.sync="seo_title"
                    :default-image="previewImage || ''"
                    default-schema="CollectionPage"
            />
          </CCol>
        </CRow>
      </div>
      <template #footer>
        <button type="button" class="pc-btn pc-btn--ghost" @click="closeFormModal()">انصراف</button>
        <button type="button" class="pc-btn pc-btn--primary" @click="login()">
          <CIcon name="iconCheck"/>
          <span>{{ status_form == 0 ? 'ثبت دسته' : 'ذخیره تغییرات' }}</span>
        </button>
      </template>
    </CModal>

    <CModal
      class="pl-modal pl-modal--danger"
      :show.sync="delete_modal"
      :no-close-on-backdrop="true"
      :centered="true"
      size="md"
    >
      <template #header>
        <div class="pl-modal__head">
          <span class="pl-modal__icon pl-modal__icon--danger" aria-hidden="true">
            <CIcon name="iconTrash"/>
          </span>
          <div>
            <h6 class="pl-modal__title">حذف دسته‌بندی</h6>
            <p class="pl-modal__sub">این عمل قابل بازگشت نیست</p>
          </div>
        </div>
        <button type="button" class="pl-modal__close" title="بستن" @click="delete_modal = false">×</button>
      </template>
      <div class="pl-modal__body">
        <p class="pl-modal__text">آیا مایل به حذف این دسته هستید؟</p>
        <label class="pl-modal__label">انتقال محصولات به دسته‌بندی زیر</label>
        <CSelect
          :options="items.map((item) => { return { label: item.name, value: item.id } })"
          :value.sync="selected_category_transfer"
        />
      </div>
      <template #footer>
        <button type="button" class="pl-btn pl-btn--ghost" @click="delete_modal = false">انصراف</button>
        <button type="button" class="pl-btn pl-btn--danger" @click="delete_item(); delete_modal = false">
          <CIcon name="iconTrash"/>
          <span>تأیید حذف</span>
        </button>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "@/api/http";
import listTable from '@/mixins/listTable'
import { cacheDelPrefix } from '@/utils/listCache'

export default {
  name: 'ProductCategoryList',
  mixins: [listTable],
  computed: {
    catId() {
      return this.$route.params.cat_id
    },
    listCacheKey() {
      return 'products:categories:' + this.catId
    }
  },
  data() {
    return {
      delete_modal: false,
      form_modal: false,
      selected_category_transfer: 0,
      confirm_delete_name: new Date().getTime() + '_' + this.$vnode.tag,
      name: '',
      file: [],
      color: '',
      seo_title: '',
      previewImage: null,
      description: '',
      items: [],
      fields: [
        { key: 'row', label: '#', _style: 'width:7%' },
        { key: 'image', label: 'تصویر', _style: 'width:10%' },
        { key: 'name', label: 'نام', _style: 'width:30%' },
        { key: 'operation', label: 'عملیات', _style: 'width:35%' }
      ],
      status_form: 0
    }
  },
  mounted() {
    this.get_categories()
  },
  watch: {
    '$route.params.cat_id': function () {
      this.get_categories()
    }
  },
  methods: {
    seoSlug(s) {
      return String(s || '').normalize('NFC').toLowerCase().trim().replace(/[\u200c\s_]+/g, '-').replace(/[^\p{L}\p{N}-]+/gu, '').replace(/-+/g, '-').replace(/^-|-$/g, '')
    },
    seoHtml(t) {
      return String(t || '').split(/\n+/).map((p) => '<p>' + p.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</p>').join('')
    },
    openCreateModal() {
      this.cancel_form()
      this.form_modal = true
    },
    openEditModal(item) {
      this.editDetails(item)
      this.form_modal = true
    },
    closeFormModal() {
      this.form_modal = false
      this.cancel_form()
    },
    onFormModalToggle(show) {
      if (!show) {
        this.cancel_form()
      }
    },
    cancel_form() {
      this.name = ''
      this.seo_title = ''
      this.description = ''
      this.previewImage = null
      this.file = []
      this.status_form = 0
    },
    editDetails(item) {
      this.name = item.name
      this.description = item.description
      this.seo_title = item.seo_title
      this.previewImage = item.image
      this.file = [item.image_id]
      this.status_form = item.id
    },
    get_categories() {
      const formData = new FormData()
      formData.append('cat_id', this.$route.params.cat_id)
      return this.loadTable({
        cacheKey: this.listCacheKey,
        fetch: () => axios.post('/api/admin/product/get_categories', formData, { show_pros: false }).then((r) => r.data),
        map: (data) => (data.orders || []).map((item, row_id) => ({ ...item, row_id })),
        onLoaded: (_data, items) => {
          if (items.length > 0) this.selected_category_transfer = items[0].id
        },
      })
    },
    invalidateCategoryCache() {
      cacheDelPrefix('products:categories:')
    },
    goSubCategories(item) {
      this.$router.push({ path: '/dashboard/products/category/' + item.id })
    },
    login() {
      const self = this
      const formData = new FormData()
      let url
      if (this.status_form == 0) {
        url = '/api/admin/product/insert_category'
      } else {
        url = '/api/admin/product/update_category'
        formData.append('id', this.status_form)
      }

      formData.append('image', this.file[0])
      formData.append('name', this.name)
      formData.append('seo_title', this.seo_title)
      formData.append('cat', this.$route.params.cat_id)
      formData.append('description', this.description)

      axios.post(url, formData, {}).then(async (res) => {
        const seoId = self.status_form == 0 ? res.data.id : self.status_form
        if (res.data.error == 0 && seoId && self.$refs.seo) await self.$refs.seo.save(seoId)
        self.$root.modal_component.show_api_response_modals(res)
        if (res.data.error == 0) {
          self.closeFormModal()
          self.invalidateCategoryCache()
          self.get_categories()
        }
      }).catch(function (error) {
        console.log(error)
      })
    },
    delete_item_dialog(item) {
      this.delete_modal = true
      this.status_form = item.id
    },
    delete_item() {
      const self = this
      const formData = new FormData()
      formData.append('id', this.status_form)
      formData.append('transfer_id', this.selected_category_transfer)

      axios.post('/api/admin/product/delete_category', formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res)
        self.status_form = 0
        self.invalidateCategoryCache()
        self.get_categories()
      }).catch(function (error) {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.category-list-page {
  padding: 0 0 24px;
  margin-left: -15px;
  margin-right: -15px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pc-card {
  background: var(--panel-surface, #fff);
  border: 1px solid var(--panel-border, rgba(128, 148, 174, .14));
  border-radius: 16px;
  box-shadow: none;
  overflow: hidden;
}

.pc-card__header {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border-bottom: 1px solid var(--panel-border, rgba(128, 148, 174, .14));
}

.pc-card__title-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.pc-card__icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: var(--panel-accent-soft, #eff6ff);
  color: var(--panel-accent, var(--accent, #2563eb));
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.pc-card__icon .c-icon {
  width: 20px;
  height: 20px;
}

.pc-card__title {
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  color: var(--panel-text, #364a63);
  line-height: 1.3;
}

.pc-card__sub {
  margin: 2px 0 0;
  font-size: 12px;
  color: var(--panel-muted, #8094ae);
}

.pc-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.pc-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 36px;
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid transparent;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background .15s ease, color .15s ease, border-color .15s ease, transform .12s ease;
  white-space: nowrap;
}

.pc-btn .c-icon {
  width: 16px;
  height: 16px;
}

.pc-btn:active {
  transform: scale(.98);
}

.pc-btn--primary {
  background: #111111 !important;
  color: #ffffff !important;
  border-color: #111111 !important;
}

.pc-btn--primary span,
.pc-btn--primary .c-icon,
.pc-btn--primary ::v-deep .c-icon,
.pc-btn--primary ::v-deep path {
  color: #ffffff !important;
  stroke: #ffffff !important;
  fill: none;
}

.pc-btn--ghost {
  background: var(--panel-surface-2, #f7f8fb);
  color: var(--panel-text, #364a63);
  border-color: var(--panel-border, rgba(128, 148, 174, .2));
}

.pc-btn--ghost:hover {
  background: var(--panel-accent-soft, #eff6ff);
  color: var(--panel-accent, var(--accent, #2563eb));
  border-color: var(--accent-ring, rgba(37, 99, 235, .25));
}

.pc-btn--sm {
  min-height: 30px;
  padding: 4px 10px;
  font-size: 12px;
}

.pc-card__body {
  padding: 12px 16px 16px;
}

.pc-muted {
  color: var(--panel-muted, #8094ae);
  font-size: 13px;
}

.pc-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--panel-text, #364a63);
}

.pc-thumb {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid var(--panel-border, rgba(128, 148, 174, .14));
  background: var(--panel-surface-2, #f7f8fb);
}

.pc-thumb ::v-deep img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.pc-ops-cell {
  vertical-align: middle !important;
}

.pc-ops {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}

.pc-icon-btn {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid var(--panel-border, rgba(128, 148, 174, .2));
  background: var(--panel-surface, #fff);
  color: var(--panel-nav, #6e82a5);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: background .15s ease, color .15s ease, border-color .15s ease;
}

.pc-icon-btn .c-icon {
  width: 14px;
  height: 14px;
}

.pc-icon-btn--warn { color: #d97706; border-color: rgba(217, 119, 6, .25); }
.pc-icon-btn--danger { color: #dc2626; border-color: rgba(220, 38, 38, .25); }
.pc-icon-btn--info { color: #2563eb; border-color: rgba(37, 99, 235, .25); }

.pc-icon-btn--warn:hover { background: rgba(217, 119, 6, .1); color: #d97706; }
.pc-icon-btn--danger:hover { background: rgba(220, 38, 38, .1); color: #dc2626; }
.pc-icon-btn--info:hover { background: rgba(37, 99, 235, .1); color: #2563eb; }

.pc-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 40px 16px;
  text-align: center;
}

.pc-empty__icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--panel-accent-soft, #eff6ff);
  color: var(--panel-accent, var(--accent, #2563eb));
  margin-bottom: 4px;
}

.pc-empty__icon .c-icon {
  width: 22px;
  height: 22px;
}

.pc-empty__title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: var(--panel-text, #364a63);
}

.pc-empty__sub {
  margin: 0 0 8px;
  font-size: 12px;
  color: var(--panel-muted, #8094ae);
}

.pc-form ::v-deep .form-control,
.pc-form ::v-deep textarea {
  border-radius: 10px;
}

.category-list-page ::v-deep .panel-table-wrap {
  border-radius: 12px;
}

.category-list-page ::v-deep .panel-table__head th {
  padding: 9px 8px !important;
  font-size: 12px;
}

.category-list-page ::v-deep .panel-table tbody td {
  padding: 9px 8px !important;
  font-size: 13px;
}

.category-list-page ::v-deep .modal-footer {
  display: flex;
  gap: 8px;
  justify-content: flex-start;
}

@media (min-width: 768px) {
  .pc-card__header {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 16px 20px;
  }

  .pc-card__body {
    padding: 12px 20px 20px;
  }

  .pc-card__title {
    font-size: 20px;
  }
}

@media (max-width: 575.98px) {
  .category-list-page {
    margin-left: -10px;
    margin-right: -10px;
  }
}
</style>
